import type { SlugConfig } from './config.js';

/** `smyk-01-nikola-iljucokova` from "SMYK 01: Nikola Iljučoková". Matches Sveltia's ascii + clean_accents. */
export function slugify(text: string, config: SlugConfig = {}): string {
  let s = String(text ?? '');
  if (config.clean_accents !== false) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
  s = s.toLowerCase();
  s = config.encoding === 'unicode' ? s.replace(/[^\p{L}\p{N}]+/gu, '-') : s.replace(/[^a-z0-9]+/g, '-');
  s = s.replace(/^-+|-+$/g, '');
  const max = config.max_length ?? 60;
  if (s.length > max) {
    const cut = s.slice(0, max);
    s = cut.includes('-') && cut.lastIndexOf('-') > max / 2 ? cut.slice(0, cut.lastIndexOf('-')) : cut;
  }
  return s || 'entry';
}

/**
 * Fill a template like `{{speaker}} | {{title}}`. Dots reach into objects; `{{slug}}` is the entry's file name.
 * Missing values become empty strings.
 */
export function renderTemplate(template: string, data: Record<string, unknown>, extra: Record<string, unknown> = {}): string {
  return template.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, path: string) => {
    const value = path.split('.').reduce<unknown>((cur, key) => (cur && typeof cur === 'object' ? (cur as any)[key] : undefined), { ...data, ...extra });
    if (value === undefined || value === null) return '';
    if (Array.isArray(value)) return value.join(', ');
    return String(value);
  }).replace(/\s+/g, ' ').trim();
}

/** A slug that doesn't collide with `taken` (adds -2, -3…). */
export function uniqueSlug(base: string, taken: Set<string>): string {
  if (!taken.has(base)) return base;
  for (let i = 2; ; i++) if (!taken.has(`${base}-${i}`)) return `${base}-${i}`;
}
